import {AxiosInstance} from 'axios';
import {RankingEntry} from '../model/RankingEntry';
import createAxiosInstance from './AxiosInstance';

export const RANKING_TYPES = [
    'puke', 'evening', 'expense', 'weeklyTarget', 'doublers', 'helpingFriends', 'helpReceived', 'record',
] as const;

export type RankingType = typeof RANKING_TYPES[number];

const normalizeRankings = (raw: unknown): RankingEntry[] => {
    if (!Array.isArray(raw)) return [];

    return raw
        .map((entry: any) => ({
            name: typeof entry?.name === 'string' ? entry.name : 'Onbekend',
            data: Number(entry?.data ?? 0),
            profilePictureUrl: entry?.profilePictureUrl ?? null,
        }))
        .sort((first, second) => second.data - first.data);
};

export const getRankings = async (
    type: RankingType,
    client: AxiosInstance = createAxiosInstance(),
): Promise<RankingEntry[]> => {
    const response = await client.get<unknown>('/rankings', {params: {type}});
    return normalizeRankings(response.data);
};
